import { createApi } from '@reduxjs/toolkit/query/react'
import { generateRPCQuery, getBaseQuery } from './apiUtils'
import apiConstants from './constants'

export const imagesApi = createApi({
  reducerPath: 'imagesApi',
  refetchOnFocus: false,
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    getImageUploadParams: builder.query({
      query: (requestParams: GetImageUploadParams) =>
        generateRPCQuery(
          apiConstants.IMAGES_RPC_PATH,
          'getImageUploadParams',
          requestParams
        )
    })
  })
})

export const { useLazyGetImageUploadParamsQuery } = imagesApi
